import { render, staticRenderFns } from "./point-cash-card.vue?vue&type=template&id=2d050e00&"
import script from "./point-cash-card.vue?vue&type=script&lang=js&"
export * from "./point-cash-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports